// extracted by mini-css-extract-plugin
module.exports = {"flexWrapper":"Paragraph-module--flexWrapper--2Etu9","serif":"Paragraph-module--serif--2BRv3","sans":"Paragraph-module--sans--3yDfA"};